<template>
  <section class="form-section">
    <h1 class="form-section__title">
      {{ $t('ADVERTISEMENT.NEGATIVE_KEYWORDS.TITLE') }}
    </h1>
    <p class="content__description">
      {{ $t('ADVERTISEMENT.NEGATIVE_KEYWORDS.DESC') }}
    </p>

    <div class="bids-btns-container">
      <div>
        <ElButton
          native-type="button"
          type="primary"
          icon="el-icon-plus"
          @click.native="openModal('showAddNegativeKeyword')"
        >
          {{ $t('ADVERTISEMENT.NEGATIVE_KEYWORDS.ADD_TITLE') }}
        </ElButton>
      </div>
    </div>

    <AddNegativeKeywordModal
      v-model="showAddNegativeKeyword"
      @add="addNegativeKeyword"
    />

    <CardApiError
      v-if="apiError"
      :error-text="$t('ADVERTISEMENT.NEGATIVE_KEYWORDS.API_ERROR')"
      @retry="getNegativeKeywords"
    />
    <NegativeKeywordsList
      :negative-keywords="negativeKeywords"
      :is-loading="isLoading"
      @deleted="deleteNegativeKeyword"
    />
  </section>
</template>

<script>
import NegativeKeywordsList from './NegativeKeywordsList';
import AddNegativeKeywordModal from './AddNegativeKeywordModal';

import NegativeKeyword from '@/api/negative-keyword';

import campaignId from '@/mixins/advertisement/campaignId';
import modal from '@/mixins/modal';

export default {
  name: 'NegativeKeyword',
  components: {
    NegativeKeywordsList,
    AddNegativeKeywordModal,
  },
  mixins: [campaignId, modal],
  data() {
    return {
      negativeKeywords: [],
      isLoading: false,
      showAddNegativeKeyword: false,
      apiError: false,
    };
  },
  mounted() {
    this.getNegativeKeywords();
  },
  methods: {
    addNegativeKeyword(negativeKeyword) {
      this.negativeKeywords.unshift(negativeKeyword);
    },
    deleteNegativeKeyword(id) {
      this.negativeKeywords = this.negativeKeywords.filter(
        keyword => keyword.id !== id,
      );
    },
    getNegativeKeywords() {
      this.isLoading = true;
      this.apiError = false;
      return NegativeKeyword.getNegativeKeywords(this.campaignId)
        .then(negativeKeywords => {
          this.negativeKeywords = negativeKeywords;
        })
        .catch(({ message }) => {
          this.apiError = true;
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
